<template>
  <div class="policy-txt">
    선택적 개인정보의 수집 및 이용 목적<br>
    - 수집/이용 목적 : 주문/결제 시 상품 배송<br>
    - 수집 항목 : 구매자 정보, 상품 구매/취소/반품/교환/환불 정보, 수령인 정보<br>
    - 보유/이용 기간 : 회원 탈퇴 후 5일까지
  </div>
</template>

